const SignalRTypes = {
    START_FETCH_TRANSACTIONS: 'START_FETCH_TRANSACTIONS',
}

export default SignalRTypes
